import EnfermedadPreexistenteTipos from './EnfermedadPreexistenteTipos';
import PrexistenciaService from '../../../api/PrexistenciaService';
import ModalErrorAction from '../../main/ModalErrorAction';

export const ingresarEnfermedadPreexistenteAction = (enfermedad) => {
    return {
        type: EnfermedadPreexistenteTipos.data.INGRESAR_ENFERMEDAD,
        payload: { tieneEnfermedadPreexistente: enfermedad }
    }
};

export const enfermedadSeleccionadaPorElSocio = (enfermedad) => {
    return {
        type: EnfermedadPreexistenteTipos.data.INGRESAR_ENFERMEDAD_SOCIO,
        payload: { tieneEnfermedadPreexistente: enfermedad }
    }
};

export const obtenerListaDeEnfermedades = () => {
    return async dispatch => {
        try {
            dispatch({
                type: EnfermedadPreexistenteTipos.data.OBTENER_ENFERMEDADES_PRE_EXISTENTES_PENDIENTE,
                payload: { enEjecucionAPIEnfermedadesPreExistentes: true }
            });
            const respuestaServicioEnfermedades = await PrexistenciaService.obtenerListaEnfermedadesPreExistente();
            if (respuestaServicioEnfermedades.data) {
                dispatch({
                    type: EnfermedadPreexistenteTipos.data.OBTENER_ENFERMEDADES_PRE_EXISTENTES_EXITO,
                    payload: { lista: respuestaServicioEnfermedades.data.enfermedadPreexistente }
                });
            } else {
                dispatch({ type: EnfermedadPreexistenteTipos.data.ERROR, payload: "error" });
                dispatch(ModalErrorAction(true));
            }

        }
        catch (error) {
            dispatch({ type: EnfermedadPreexistenteTipos.data.ERROR, payload: error });
            dispatch(ModalErrorAction(true));
        }
    };
};